import { FilterOption } from '~/components/filter/filter-options';
import { DateTimeProperties } from '~/utils/datetime/date-time-properties';

export interface FilterModel {
	andJoin?: boolean;
	filterOptions?: FilterOption[]; // = [];
	hidden?: boolean; // = false;
	ignoreCase?: boolean; // true;
	not?: boolean; // false;
	operation?: FilterOption;
	upperValue?: string;
	value?: string | string[];
	dateTimeProperties?: DateTimeProperties;
}

export const createFilterModel = (
	{
		andJoin,
		filterOptions = [],
		hidden = false,
		ignoreCase = true,
		not = false,
		operation,
		upperValue,
		value,
	}: FilterModel = {
		filterOptions: [],
		hidden: false,
		ignoreCase: true,
		not: false,
	} as FilterModel,
) => {
	return {
		andJoin,
		filterOptions,
		hidden,
		ignoreCase,
		not,
		operation,
		upperValue,
		value,
	} as FilterModel;
};
